module.exports = __webpack_public_path__ + "static/media/heart-on.06b58696.svg";